<template>
  <div class="admin-page" :style="bgStyle">
    <div class="admin-content">
      <div class="admin-card">
        <img
          :src="isMobile ? '/ejecutivo/logo movil.png' : '/ejecutivo/logotipo.png'"
          alt="Movistar Empresas"
          class="admin-logo"
        />
        <h1 class="admin-title font-light">Bienvenido</h1>
        <div class="admin-download">
          <p class="download-label">Descarga base de datos:</p>
          <a :href="exportUrl" class="btn-download btn-download--large" target="_blank">Aquí</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistroB2Badmin',
  data() {
    return {
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/ejecutivo/fondo_movil_ya.jpg' : '/ejecutivo/fondo_ya.jpg';
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'center center'
      }
    },
    exportUrl() {
      return this.$api.baseUri + 'ejecutivo/leads/export/ejecutivo';
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    }
  }
}
</script>

<style scoped>
.admin-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
}

.admin-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20vw;
}

.admin-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.admin-logo {
  width: clamp(280px, 30vw, 480px);
  height: auto;
  margin-bottom: clamp(30px, 4vw, 60px);
}

.admin-title {
  color: #fff;
  font-size: clamp(32px, 3.5vw, 54px);
  margin: 0 0 clamp(40px, 5vw, 80px);
  font-family: TelefonicaLight, sans-serif;
}

.admin-download {
  text-align: center;
}

.download-label {
  color: #fff;
  font-size: clamp(16px, 1.4vw, 22px);
  font-weight: bold;
  margin-bottom: clamp(14px, 1.5vw, 24px);
  font-family: TelefonicaRegular, sans-serif;
}

.btn-download {
  display: inline-block;
  width: clamp(120px, 12vw, 200px);
  padding: clamp(6px, 0.5vw, 10px);
  border: none;
  border-radius: 30px;
  background: #E535AB;
  color: #fff;
  font-size: clamp(18px, 1.6vw, 26px);
  cursor: pointer;
  transition: background 0.25s;
  font-family: TelefonicaRegular, sans-serif;
  text-decoration: none;
  text-align: center;
}

.btn-download:hover {
  background: #c92d96;
}

/* MOBILE */
@media (max-width: 768px) {
  .admin-content {
    padding-left: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 28px 40px;
  }
  .admin-logo {
    width: 260px;
    margin-bottom: 38vh;
  }
  .admin-title {
    font-size: 26px;
    margin-bottom: 30px;
  }
  .download-label {
    font-size: 16px;
  }
  .btn-download {
    width: 150px;
    padding: 10px;
    font-size: 20px;
  }
}
</style>
